import { render, staticRenderFns } from "./algo-task-third.html?vue&type=template&id=7d5783df&scoped=true&"
import script from "./algo-task-third.js?vue&type=script&lang=js&"
export * from "./algo-task-third.js?vue&type=script&lang=js&"
import style0 from "./algo-task-third.scss?vue&type=style&index=0&id=7d5783df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5783df",
  null
  
)

export default component.exports